<template>
  <div :class="['layout-head-nav', $route.name !== 'home' ? 'border' : '']">
    <el-menu
      :default-active="activeMenu.path"
      text-color="#333333"
      active-text-color="#fff"
      :unique-opened="true"
      mode="horizontal"
      :class="['f-b-c def-w', $route.name !== 'home' ? 'border' : '']"
    >
      <nav-item
        v-for="route in menus"
        :key="route.id"
        :active-index="activeMenu.path"
        :item="route"
        :base-path="route.path"
      />
    </el-menu>
  </div>
</template>

<script>
import NavItem from "@/layout/components/LayoutHead/HeadNav/NavItem.vue";
import { mapGetters } from "vuex";
export default {
  name: "HeadNav",
  components: { NavItem },
  props: {},
  data() {
    return {};
  },

  computed: {
    ...mapGetters(["menus", "activeMenu"]),
  },
  watch: {},

  created() {},

  mounted() {},

  methods: {},
};
</script>

<style scoped lang="scss">
.layout-head-nav {
  width: 100%;
  height: 60px;
  background-color: #fff;
  :deep(.el-menu.el-menu--horizontal) {
    height: 60px;
    .el-submenu {
      height: 60px;
      .el-submenu__title {
        height: 60px;
        line-height: 60px;
      }
    }
    .el-menu-item {
      height: 60px;
      line-height: 60px;
    }
  }
}
.border {
  border-bottom: 2px solid $--color-primary !important;
}
</style>
